module.exports = __webpack_public_path__ + "static/media/logo-plain-long.07bc7b31.svg";